import * as moment from 'moment-timezone';

export const Timezones = {
  local: 'America/Chicago'
};

export function FormatDateFilter(TIMEZONES) {
  'ngInject';

  return function (milliseconds, dateFormat) {
    return milliseconds
      ? moment.tz(milliseconds, TIMEZONES.local).format(dateFormat)
      : '';
  };
}
